<div class="page-container">
    <div class="d-sm-flex align-items-center justify-content-between mb-4" style="border-bottom:2px solid grey;">
        <h1 class="h3 mb-0 text-gray-800">Access Permission</h1>
    </div>

    <div class="table-wrapper">
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" class="full-width">

                <!-- Menu Column -->
                <ng-container matColumnDef="menu">
                    <th mat-header-cell *matHeaderCellDef> Menu </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-icon>{{ row.menuIcon }}</mat-icon> {{ row.menuTitle }}
                    </td>
                </ng-container>

                <!-- Sub Menu Column -->
                <ng-container matColumnDef="subMenu">
                    <th mat-header-cell *matHeaderCellDef> Sub Menu </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-icon>{{ row.subIcon }}</mat-icon> {{ row.subTitle }}
                    </td>
                </ng-container>

                <!-- Permission Column -->
                <ng-container matColumnDef="permission">
                    <th mat-header-cell *matHeaderCellDef> Permission </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-form-field appearance="outline">
                            <mat-select [(ngModel)]="row.userTypes" multiple>
                                <mat-option *ngFor="let u of userTypes" [value]="u" [disabled]="u === 'Admin'">
                                    {{ u }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-raised-button color="primary" (click)="saveRow(row)">Save</button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>

    <div class="pagination-wrapper">
        <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(1)">First</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(pager.currentPage - 1)">Prev</a>
            </li>
            <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                <a (click)="setPage(page)">{{page}}</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.currentPage + 1)">Next</a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.totalPages)">Last</a>
            </li>
        </ul>
    </div>
</div>